import { createContext, useContext } from 'react';

type ModalContextProps = {
  onClose: () => void;
};

export const ModalContext = createContext<ModalContextProps>({
  onClose: () => null,
});

export const useModalContext = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModalContext must be used within a ModalContext');
  }
  return context;
};
